import { useCallback } from "react";

import HeroSection from "../../Components/HeroSection";
import HowItWorksSection from "../../Components/HowItWorksSection";
import BookSpotForm from "../../Components/BookSpotForm";
import BookYogaNutritionTrialRibbon from "../../Components/BookYogaNutritionTrialRibbon";
import WhatMakesShyftBootCampUniqueSection from "../../Components/WhatMakesShyftBootCampUniqueSection";
import CallbackSection from "../../Components/CallbackSection";
import Testimonials from "@/components/Organisms/TestimonialsV2";
import RealWorldTransformation from "../../Components/RealWorldTransformation";
import AppBannerSection from "../../Components/AppBannerSection";
import CallbackStrip from "../../Components/CallbackStrip";
import BootcampListing from "../../Components/BootcampListing";
import AllPackagesSection from "../../Components/AllPackagesSection";
import ReadyToBuildSection from "../../Components/ReadyToBuildSection";
import FaqSection from "@/components/Molecules/FaqSection";
import FloatingBanner from "../../Components/FloatingBanner";
import BookSlotModal from "../../Components/BookSlotModal";
import BookTrialClassModal from "../../Components/BookTrialClassModal";
import CustomIntercomButton from "../../Components/CustomIntercomButton";

import CertifiedInstructors from "../../Components/Shared/CertifiedInstructors";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./YogaBootcampPage.module.scss";
import CourseDetails from "../../Components/CourseDetails";
import WhatYouWillLearn from "../../Components/WhatYouWillLearn";
import InstructorDetails from "../../Components/InstructorDetails";
import ProsAndVideoSection from "../../Components/ProsAndVideoSection";

interface YogaBootcampPageProps { }

const YogaBootcampPage: React.FC<YogaBootcampPageProps> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);
  const {hideBenefitSectionClassWeb} = data?.heroSection
  const { testimonies } = data?.testimonials || {};
  const faqs = data?.faqs || {};

  const showBookTrialClassModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookTrialClassModal(value));
    },
    [dispatch]
  );

  return (
    <div className={cls("yogaBootcampPage")}>
      <HeroSection />
      <HowItWorksSection>
        <BookSpotForm />
      </HowItWorksSection>
      <BookYogaNutritionTrialRibbon
        onCTAClick={() =>
          showBookTrialClassModal({
            packageData: data?.trialData,
          })
        }
      />
      <WhatMakesShyftBootCampUniqueSection />
      <ProsAndVideoSection />
      <CourseDetails />
      <WhatYouWillLearn />
      <Testimonials testimonies={testimonies} 
        className={hideBenefitSectionClassWeb}
      />
      <InstructorDetails />
      <CallbackSection />
      <RealWorldTransformation />
      <AllPackagesSection />
      <AppBannerSection />
      <CallbackStrip />
      {
        data?.bookConsultation?.whatHappensNext &&
        <div className={cls("certifiedInstructors")}>
          <CertifiedInstructors />
        </div>
      }
      <BootcampListing />
      <FaqSection {...faqs} 
        className={hideBenefitSectionClassWeb}
      />
      <ReadyToBuildSection />
      <FloatingBanner />
      <BookSlotModal title={data?.bookSlotForm?.title} />
      <BookTrialClassModal />
      {/* <CustomIntercomButton /> */}
    </div>
  );
};

export default YogaBootcampPage;
